import { Link, useLocation } from "react-router-dom";
import "./Partnership.css";

import ArrowIcon from "../../Assets/Icons/Vector.svg";
const Logo1 ="https://res.cloudinary.com/davmkct9m/image/upload/v1769584836/logo1_ayi2ny.jpg";
const Logo2 ="https://res.cloudinary.com/davmkct9m/image/upload/v1769584836/logo2_xyp79f.jpg";
const Logo3 ="https://res.cloudinary.com/davmkct9m/image/upload/v1769584836/logo3_rqihaa.png";
const Logo4 ="https://res.cloudinary.com/davmkct9m/image/upload/v1769584836/logo4_biti3u.png";
const Logo5 ="https://res.cloudinary.com/davmkct9m/image/upload/v1769584836/logo5_g76yma.png";
const Logo6 ="https://res.cloudinary.com/davmkct9m/image/upload/v1769584836/logo6_z1yivk.png";
const Logo7 ="https://res.cloudinary.com/davmkct9m/image/upload/v1769584836/logo7_fsvkvi.png";
const Logo8 ="https://res.cloudinary.com/davmkct9m/image/upload/v1769584836/logo8_m26jfv.png";
const Logo9 ="https://res.cloudinary.com/davmkct9m/image/upload/v1769584837/logo9_jdyvl9.png";

const logoSet1 = [
  Logo1,
  Logo2,
  Logo3,
  Logo4,
  Logo5,
  Logo6,
  Logo7,
  Logo8,
  Logo9,
];

const logoSet2 = [
  Logo9,
  Logo8,
  Logo7,
  Logo6,
  Logo5,
  Logo4,
  Logo3,
  Logo2,
  Logo1,
];

const PartnershipPage = () => {
  const location = useLocation();
  const isTechnologiesPage = location.pathname === "/technologies";

  return (
    <div
      id="partner"
      className={`partnership-container ${
        isTechnologiesPage ? "partnership-container--compact" : ""
      }`}
    >
      <div className=" container">
        <div className="row">
          {/* Left Part */}
          <div className="col-lg-6  tab-view">
            <h2 className="partnership-title">Built On Partnership</h2>
            <p className="partnership-text">
              The best software is never built in a silo. We extend your
              organization, working together from day one, with collective
              ownership, accountability, and success built on trust,
              transparency, and a clear understanding of your needs, not
              contracts or timelines.
            </p>
            <Link to="/contact-us/build-business">
              <button className="btn start-btn">
                Start a Conversation
                <img
                  width={7}
                  className="space-left"
                  src={ArrowIcon}
                  alt="arrow--icon"
                />
              </button>
            </Link>
          </div>

          {/* Right Part */}
          <div className="col-lg-6">
            <div className="slider-container">
              <div className="logo-slider">
                {[...logoSet1, ...logoSet1].map((src, i) => (
                  <div key={i} className="logo-slide">
                    <img src={src} alt={`Partner Logo #${i + 1}`} />
                  </div>
                ))}
              </div>
            </div>

            <div className="slider-container">
              <div className="logo-slider uno-reverse">
                {[...logoSet2, ...logoSet2].map((src, i) => (
                  <div key={i} className="logo-slide">
                    <img src={src} alt={`Partner Logo #${i + 10}`} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnershipPage;
